import { safeDefine } from "../../registration/safe-define.js";
import { LiveAudioSkinElement } from "../../presets/live-audio/skin.js";
import "../../internal/skins/default-live-audio/register.js";
//#region src/define/live-audio/skin.ts
safeDefine(LiveAudioSkinElement);
//#endregion

//# sourceMappingURL=skin.js.map